import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Global } from "../classes/Global";
import { Router } from "@angular/router";
import { BaseComponent } from '../classes/BaseComponent';
import { PriceHelper } from '../helpers/PriceHelper';
import { ListHelper } from '../helpers/ListHelper';
import { Config } from '../classes/Config';
import { DateHelper } from '../helpers/DateHelper';
import { StringHelper } from '../helpers/StringHelper';

@Component({
  selector: 'app-grid-item-blocklist',
  templateUrl: './grid-item-blocklist.component.html',
  styleUrls: ['./grid-item-blocklist.component.scss']
})
export class GridItemBlocklistComponent extends BaseComponent implements OnInit {

  id;
  highResImageLoaded = false;
  showPlaceHolder: boolean = false;

  imageContainerClass: string;
  imageClass: string;
  footerClass: string;
  gridItemClass: string;
  detailViewUrl: string;

  @Input() item;
  @Input() priceHint;
  @Input() store: string;
  @Output() onItemClicked = new EventEmitter();
  @Output() onRemoveFromBlocklistClicked  = new EventEmitter();

  constructor(
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    if (this.item) {
      this.id = this.item.idInStore || this.item.itemID;

      if (this.id) {
        let media = Global.getMediaTypeForDetailView();
        const country = Global.getCountry();
        const storeUrl = Global.getStoreUrl();
        const mediaUrl = this.getString(media + 'Url');
        const title = this.item.title;

        if (country && storeUrl && mediaUrl && title) {
          this.detailViewUrl = '/' + country + '/' + storeUrl + '/' + mediaUrl + '/' + this.id + '/' + StringHelper.slugify(title);
        } else {
          this.detailViewUrl = "";
        }
      } else {
        this.detailViewUrl = "";
      }

      this.gridItemClass = this.getGridItemClass();
      this.imageContainerClass = this.getImageContainerClass();
      this.imageClass = this.getImageClass();
      this.footerClass = this.getFooterClass();
    }
  }

  getItemImageUrl(): string {
    if (this.id) {
      return Config.imageServerUrl + Global.getCountry() + "/" + this.id + "/400x400.jpg";
    }
    return "";
  }

  getHttpsImageUrl() {
    const url = this.item.imageLargeUrl || this.item.itemImageURL || this.item.imageMediumUrl || this.item.imageSmallUrl || '';
    return StringHelper.getImageHttpsUrl(url);
  }

  isInBlocklist(): boolean {
    return ListHelper.isItemInBlocklist(this.item);
  }

  hasRectangleImage(): boolean {
    // Seasons are squared images on iTunes, but rectangle images on Vudu
    if (this.item.itemType == "season" && this.store == "vudu") {
      return true; // Use rectangle image for landscape seasons on Vudu
    }
    return this.item.itemType == "movie" || this.item.itemType == "ebook";
  }

  formatPrice(price: number, currency: string): string {
    if (price && currency) {
      return PriceHelper.formatPrice(price, currency);
    }
    else {
      return "";
    }
  }

  removeFromBlocklist(e) {
    e.stopPropagation();
    e.preventDefault();
    this.onRemoveFromBlocklistClicked.emit();
    return false;
  }

  urlIsBlocklist(): boolean {
    return this.router.url.indexOf("Blocklist") > -1;
  }

  urlIsHomePage(): boolean {
    return this.router.url == "/";
  }

  getImageContainerClass(): string {
    let classString =  this.hasRectangleImage() ? this.getRectangleImageClass() : this.getSquareImageClass();
    classString += " image-container";
    return classString;
  }

  getRectangleImageClass(): string {
    return 'rectangle-image';
  }

  getSquareImageClass(): string {
    return 'square-image';
  }

  getImageClass(): string {
    let classString = 'item-image ';
    if (this.hasRectangleImage()) {
      classString += this.getRectangleImageClass();
    }
    else {
      classString += this.getSquareImageClass();
    }
    if (this.item.itemType == "app") {
      classString += " rounded-top-border";
    }
    return classString;
  }

  getFooterClass(): string {
    let classString = 'grid-item-footer';
    return classString;
  }

  getGridItemClass(): string {
    let classString = 'grid-item';
    if (this.item.itemType == "app") {
      classString += " rounded-top-border";
    }
    return classString;
  }

  useIvan(): boolean {
    return Config.useIvan;
  }

  storeIsItunes(): boolean {
    return this.store == Global.ITUNES;
  }

  getTimeAgoString(): string {

    if (!this.item.blocklistInfo) {
      return "";
    }

    const date: Date = DateHelper.dateStringToDateObject(this.item.blocklistInfo.addedToBlocklistAt);
    if (!date) {
      return "";
    }

    const timeAgo = DateHelper.getTimeAgo(date, "day");
    if (!timeAgo) {
      return "";
    }

    if (timeAgo["text"]) {
      return StringHelper.lowCaseFirstLetter(this.getString(timeAgo["text"]));
    }

    return StringHelper.format(this.getString("timeAgo"), timeAgo.value, this.getString(timeAgo.unit));

  }

  getStartPrice(): number {
    let startPrice;
    if (this.item && this.item.blocklistInfo) {
      if (this.item.blocklistInfo.isMarkedAsBuyItem == true) {
        if (this.item.blocklistInfo.initialBuyHdPriceValue &&
          this.item.blocklistInfo.initialBuyHdPriceValue != -1) {
          startPrice = this.item.blocklistInfo.initialBuyHdPriceValue;
        }
        else {
          startPrice = this.item.blocklistInfo.initialBuySdPriceValue;
        }
      }
      else {
        if (this.item.blocklistInfo.initialRentalHdPriceValue &&
          this.item.blocklistInfo.initialRentalHdPriceValue != -1) {
          startPrice = this.item.blocklistInfo.initialRentalHdPriceValue;
        }
        else {
          startPrice = this.item.blocklistInfo.initialRentalSdPriceValue;
        }

      }
    }

    return startPrice;
  }

  getStartPriceAsString(): string {

    const startPrice = this.getStartPrice();

    if (startPrice == 0) {
      return this.getString("free");
    }
    return this.formatPrice(startPrice, this.item.currency);
  }

  getAddedFor(): string {
    return StringHelper.format(this.getString("addedOn"), this.getTimeAgoString());
  }

}
